const nav_bar = {
	console: "Konsole",
	overview: "Übersicht",
	snapshots: "Snapshots",
	ssh_keys: "SSH-Schlüssel",
};

export default nav_bar;
